import { parseNumber, parseString } from 'utils/parsingHelpers'

export enum Supplier {
  Gecko = 'gecko',
  Customer = 'customer',
}

export enum AssetAccess {
  JLG = 'jlg',
  Scaffolding = 'scaffolding',
  Ladder = 'ladder',
  Stairs = 'stairs',
  SkyClimber = 'sky_climber',
  Ground = 'ground',
  Manway = 'manway',
}

export interface SiteDetailsJSON {
  water_connectors?: string
  asset_access?: {
    access_type: AssetAccess[]
    jlg_supplier?: Supplier
    jlg_size?: number
    manway_size?: number
  }
  water_supplier?: Supplier
  water_details?: string
  power_supplier?: Supplier
  power_details?: string
  gate_details?: string
}

export const getSupplier = (value: string | undefined) => {
  if (Object.values(Supplier).includes(value as Supplier)) {
    return value as Supplier
  }
  return undefined
}

export const getAssetAccessArray = (values: string[]): AssetAccess[] => {
  if (
    values.every((value) =>
      Object.values(AssetAccess).includes(value as AssetAccess)
    )
  ) {
    return values as AssetAccess[]
  }
  return []
}

export const parseSiteDetailsJSON = (
  value: unknown
): SiteDetailsJSON | undefined => {
  if (!value || typeof value !== 'object') return undefined

  const data = value as Record<string, unknown>
  const assetAccess = data.asset_access as Record<string, unknown> | undefined
  return {
    water_connectors: parseString(data.water_connectors),
    asset_access: assetAccess
      ? {
          access_type: getAssetAccessArray(
            Array.isArray(assetAccess.access_type)
              ? assetAccess.access_type.map((x) => String(x))
              : []
          ),
          jlg_supplier: getSupplier(parseString(assetAccess.jlg_supplier)),
          jlg_size: parseNumber(assetAccess.jlg_size),
          manway_size: parseNumber(assetAccess.manway_size),
        }
      : undefined,
    water_supplier: getSupplier(parseString(data.water_supplier)),
    water_details: parseString(data.water_details),
    power_supplier: getSupplier(parseString(data.power_supplier)),
    power_details: parseString(data.power_details),
    gate_details: parseString(data.gate_details),
  }
}
